<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <StoreStepper current="product_categories"></StoreStepper>
            <v-layout v-if="!loadForm" row wrap>
                <v-flex>
                    <v-card>
                        <v-card-title>
                            مدیریت دسته‌بندیها
                            &nbsp;&nbsp;
                            <small> (جابجایی با کشیدن و رها کردن) </small>
                        </v-card-title>
                        <v-card-text>
                            <v-layout wrap>
                                <v-flex>
                                    <v-btn round class="green white--text" @click="linkDialog=true">+ افزودن</v-btn>
                                </v-flex>
                            </v-layout>
                            <dragTreeTable
                                    :data="treeData"
                                    :onDrag="onTreeDataChange"
                                    fixed
                                    border>
                            </dragTreeTable>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout v-if="loadForm" class="row wrap">
                <v-flex md12><fake-item></fake-item></v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
        <v-dialog
                v-model="linkDialog"
                width="50%"
        >
            <v-card>
                <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                >
                    اطلاعات دسته‌بندی
                </v-card-title>

                <v-card-text>
                    <v-flex>
                        <v-text-field
                                label="عنوان دسته‌بندی"
                                v-model="newNode.name"
                                type="text"
                        ></v-text-field>
                        <v-btn v-if="newNode.ac_id === 0" block color="green" style="color:white" @click="handleSubmit">افزودن</v-btn>
                        <v-btn v-else color="blue" block style="color:white" @click="handleEdit">ذخیره</v-btn>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import StoreStepper from '@/components/StoreStepper';
import VWidget from '@/components/VWidget';
import dragTreeTable from 'drag-tree-table';
export default {
  components: {
    StoreStepper,
    VWidget,
    dragTreeTable
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      newNode: {
        name: '',
        parent_id: 0,
        order: 0,
        ac_id: 0,
        id: 0,
        store_id: Number(this.$route.params.store_id),
        lists: [],
      },
      linkDialog: false,
      treeData: {
        columns: [
          {
            type: 'selection',
            title: 'عنوان',
            field: 'name',
            flex: 4,
            align: 'center',
            formatter: (item) => {
              return '<a>' + item.name + '</a>';
            },
          },
          {
            title: 'عملیات',
            type: 'action',
            flex: 1,
            align: 'center',
            actions: [
              {
                text: 'ویرایش',
                onclick: (item) => {
                  this.newNode = item;
                  this.linkDialog = true;
                },
                formatter: (item) => {
                  return '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--small theme--dark pink"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--dark white--text">edit</i></div></button>';
                }
              },
              {
                text: 'حذف',
                onclick: (item) => {
                  this.DeleteCat(item.ac_id);
                },
                formatter: (item) => {
                  return '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--small theme--dark red"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--dark white--text">close</i></div></button>';
                }
              }
            ]
          },
        ],
        lists: [],
        custom_field: {
          id: 'ac_id',
          order: 'sort',
          lists: 'lists',
          parent_id: 'parent_id'
        }
      },
      loadForm: true,
      loading: false,
      complex: {
        items: []
      },
      shop_name: ''
    };
  },
  created: function () {

    this.axios.get('/reseller/stores/')
      .then(response => {
        this.loadCategories();
        let i = response.data.Data.findIndex(s => s.shop_id === parseInt(this.$route.params.store_id, 10));
        if (i > -1) {
          this.shop_name = response.data.Data[i].shop_name;
        }
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
    this.loadCategories();
  },
  methods: {
    onTreeDataChange (list) {
      this.treeData.lists = list;
      let data = this.flatMaps(list);
      console.log(data);
      this.axios.post('/reseller/artwork_categories_sort/' + this.$route.params.store_id, data)
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    flatMaps: function (items) {
      return items.flatMap(l => {
        if (typeof l.lists === 'undefined' || l.lists.length === 0) {
          return l;
        }
        return [l, ...this.flatMaps(l.lists)];
      });
    },
    addNode: function () {
      if (this.newNode.id === 0) {
        this.newNode.id = Math.floor(Math.random() * 99999999);
        this.treeData.lists.push(this.newNode);
      } else {
        let t = this.treeData.lists.findIndex(i => i.id === this.newNode.id);
        this.treeData.lists[t] = this.newNode;
      }
      this.onTreeDataChange(this.treeData.lists);
      this.resetNew();
      this.linkDialog = false;
    },
    resetNew: function () {
      this.newNode = {
        name: '',
        link: '',
        ac_id: 0,
        store_id: Number(this.$route.params.store_id),
        lists: [],
      };
    },
    startCategories: function () {
      let data = [];
      let cats = this.complex.items.filter(c => c.parent_id === 0);
      cats.forEach(c => {
        c.lists = this.category(c.ac_id);
        data.push(c);
      });
      this.onTreeDataChange(data);
    },
    category: function (id) {
      let cats = this.complex.items.filter(c => c.parent_id === id);
      let data = [];
      cats.forEach(c => {
        c.lists = this.category(c.ac_id);
        data.push(c);
      });
      return data;
    },
    loadCategories () {
      this.axios.get('/reseller/artwork_categories/?store_id=' + this.$route.params.store_id)
        .then(response => {
          this.complex.items = response.data.Data.map(m => {
            m.order = m.sort;
            return m;
          }).sort((a, b) => { return a.sort > b.sort ? 0 : -1 });
      
          this.startCategories();
          this.loadForm = false;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    handleSubmit () {
      this.axios.post('/reseller/artwork_categories', {
        name: this.newNode.name,
        store_id: Number(this.$route.params.store_id),
      })
        .then(() => {
          // Response Submit Method
          this.snackbar.text = 'با موفقیت انجام شد.';
          this.snackbar.y = 'bottom';
          this.snackbar.color = 'success';
          this.snackbar.snackbar = true;
          this.loading = false;
          this.linkDialog = false;
          this.resetNew();
          this.loadCategories();
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });
    },
    handleEdit () {
      this.axios.put('/reseller/artwork_categories/' + this.newNode.ac_id, this.newNode)
        .then(response => {
        // Response Submit Method
          console.log(response);
          this.snackbar.text = 'با موفقیت انجام شد.';
          this.snackbar.y = 'bottom';
          this.snackbar.color = 'success';
          this.snackbar.snackbar = true;
          this.loading = false;
          this.linkDialog = false;
          this.resetNew();
          this.loadCategories();
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });
    },
    DeleteCat (id) {
      this.$confirm('آیا از حذف این مورد اطمینان دارید؟').then(res => {
        if (res) {
          this.axios.delete('/reseller/artwork_categories/' + id)
            .then(response => {
              this.snackbar.snackbar = true;
              this.snackbar.color = 'success';
              this.snackbar.text = response.data.messages.join(' ');
              this.loadCategories();
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/product_categories/modify.vue